<template>
  <div class="Verify">
    <template v-if="verifyStatus == 1">
      <upDataIDQr @getData="getDataFn" :classId="currentClassId"></upDataIDQr>
    </template>
    <template v-else-if="verifyStatus == 2">
      <Face
        ref="face"
        :classId="currentClassId"
        v-if="isFace"
        @isValidationFace="isValidationFace"
        @isRouter="isRouter"
      />
    </template>
    <template v-else-if="verifyStatus == 3">
      <div class="pay">
        <div class="pay-icon">
          <img class="img" src="../../assets/images/icon_pay.png" alt="">
        </div>
        <div class="pay-title">等待跳转到E签宝......</div>
      </div>
    </template>
    <template v-else-if="verifyStatus == 4">
      <div class="pay" style="width: 410px;">
        <div class="pay-icon">
          <img class="img" src="../../assets/images/icon_pay.png" alt="">
        </div>
        <div class="pay-title">等待缴费......</div>
        <p>学生： {{studentInfo.title}}，你的学号是：{{studentInfo.student_code}}</p>
        <p>请按照下方缴费方式进行缴费</p>
        <p>关注重庆医科大学财务处公众号—点击服务大厅—点击统一支付平台—点击特殊登录—输入学号和密码—点击成教及自考缴费—缴费完成后，等待10-15分钟入账—10-15分钟后返回主页点击票据查询——即可获得缴费电子票据</p>
        <!-- <p>请点击下方的缴费链接，进入重庆医科大学缴费平台进行学费缴纳</p> -->
        <!-- <el-button type="primary" round @click="jumpPaymentFn">
          重庆医科大学缴费入口 >>
        </el-button> -->
      </div>
    </template>
    <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
  </div>
</template>

<script>
import {getCheckAuthStatus, esingCreateSignFlow} from "@/api/login";
import upDataIDQr from '../business/upDataID/upDataIDQr'
import Face from "@/components/face";
import { mapState } from "vuex";
import { userInfo } from "os";

export default {
  name: "Verify",
  components: {
    Face,
    upDataIDQr,
  },
  data() {
    return {
      verifyStatus:0, // 1未上传身份证 2人脸未通过 3e签宝 4缴费 5重置密码

      isFace: false,
      adultPayUrl:"",
      currentClassId:''
    };
  },
  computed: {
    ...mapState("permission", {
      studentInfo: (state) => JSON.parse(state.userInfo), 
      _ENTRANCETYPE: state => state._ENTRANCETYPE,  //成教/自考
      enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
    }),
  },
  created() {
    this.currentClassId = this.$route.query.classId
    this.getDataFn()
  },
  mounted() {

  },
  methods: {
    // 退出
    async exit() {
      // loginOut(null).then(() => {
      // this.$store.dispatch('permission/setIsGenerateRoutes', '');
      await this.$store.dispatch('permission/logOut');
      // Cookies.remove('token');
      this.$message.success('退出成功');
      this.$router.replace("/Login");

      // });
    },
    async getDataFn(){
      let params = {
        class_id:this.currentClassId
      }
      const {code,result,msg} = await getCheckAuthStatus(params)
      if(code != 200)return
      this.verifyStatus = result.verify_status
      switch(result.verify_status){
        case 1:
          document.title = '上传身份证照片'
          break;
        case 2:
          document.title = '人脸识别'
          this.isFace = true;
          break;
        case 3:
          document.title = 'e签宝'
          this.esingCreateSignFlowFn()
          break;
        case 4:
          document.title = '缴费'
          this.adultPayUrl = result.adult_pay_url
          // let a = setTimeout(()=>{
          //   this.getDataFn()
          //   clearTimeout(a)
          // },5000)
          break;
        case 5:
          document.title = '重置密码'
          this.$router.replace({
            path: "/changePwd",
            query: {
              classId: this.currentClassId,
            },
          });
          break;
        default:
          this.$store.dispatch('permission/firstLoginVerifyActions', 1);
          if(this._ENTRANCETYPE === 'adult'){
            if(this.enterSchoolImgCheck != 2){
              this.$router.push({
                path: "/uploadAdmissionPhotos",
              });
              return
            }
          }
          this.$router.replace({
              name: "home",
          });
          break;
      }
    },
    // 关闭人脸识别
    isRouter() {
      this.isFace = false;
      this.getDataFn()
    },
    isValidationFace() {
      this.$message({
        message: "请进行人脸验证",
        type: "warning",
      });
    },

    async esingCreateSignFlowFn(){
      const params = {
        redirectUrl:this.$base.getUrl()+'#/verify?classId='+this.currentClassId,
        class_id:this.currentClassId
      }
      const {code,result,msg} = await esingCreateSignFlow(params)
      if(code != 200)return
      // window.location.href = result.shortUrl
      open(result.shortUrl, '_blank');
    },

    jumpPaymentFn(){
      window.open(this.adultPayUrl, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.Verify{
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  .exit-btn{
    position: fixed;
    top: 10px;
    right: 10px;
  }
  .pay{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &-icon{
      width: 108px;
      img{
        width: 100%;
      }
    }
    &-title{
      font-size: 22px;
      color: #333;
      font-weight: 600;
      padding-top: 40px;
    }
    p{
      font-size: 16px;
      color: #333;
      padding-top: 10px;
    }
    .el-button{
      margin-top: 20px;
    }
  }
}
</style>
